<template>
    <div class="info-page">
      <div class="home-page info-page">
        <Header></Header>
        <!-- 面包屑导航 -->
        <div class="breadcrumbs">
          <div class="breadcrumbs-content m_section_inner disflex">
            <div class="bd-ul">
              <ul class="">
                <li class="home"><a href="./">{{$t('home')}}</a></li>
                <li @click="back"><span>{{$t('Conversation')}}</span></li>
                <li><span>{{$t('Lesson')}}{{info.lesson_num}}</span></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="page_title">
          <div class="m_section_inner" style="background: linear-gradient(rgba(255,255,255,0), rgba(255,255,255,0)), url(../../static/images/grammar-bg.jpg) no-repeat 0 0 / cover ">
            <div class="disflex sub-content">
              <div class="disflex topic-header">
                <div class="topic-titles">
                  <div class="jp fw7">かいわ</div>
                  <div class="jp">{{$t('Conversation')}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grammar-content">
          <div class="detail-info mt20">
            <div class="cvation-num disflex" style="width: 60%;">
              <span class="cvation-num-l fw7">{{info.num}}</span>
              <div class="cvation-num-r">{{info.topic_en}}</div>
            </div>
            <div class="mt30 fs33">{{info.title_jp}}</div>
            <div class="mt10 fs33">{{info.title_en}}</div>
          </div>

          <div class="video">
            <div class="cando_movie_navi">
              <div class="cando_movie_changer">
                <ul class="nav-tab">
                  <li
                    :class="{ active: currentVideo === 'Skit' }"
                    @click="changeVideo('Skit')"
                  >
                    <span>{{$t('Skit')}}</span>
                  </li>
                  <li
                    :class="{ active: currentVideo === 'Video' }"
                    @click="changeVideo('Video')"
                  >
                    <span>{{$t('Video')}}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="grammar-detail">

            <div class="cando_movie_player">
              <video
              class="video-player"
                ref="videoPlayer"
                webkit-playsinline
                playsinline
                controls
                controlslist="nodownload"
                @play="onPlay('')"
                @pause="onPause('')"
                @ended="onEnded('')"
                @seeking="onSeeking('')"
                @ratechange="onRateChange('')"
                @loadedmetadata="onVideoLoaded('')"
                @error="onVideoError('')"
              >
                <source :src="videoUlr" type="video/mp4">
                Your browser does not support the video tag.
              </video>
              <div
                class="playbutton"
                :style="{ display: VideoPlaying ? 'none' : 'block' }"
                @click="playVideo('')"
              ></div>
              <div class="control"></div>
            </div>
            <div class="t" style="padding: 20px 0;">{{info.desc_en}}</div>
          </div>
          <div class="tips-content ting-content cando_navi_btn" style="padding:0;">
            <div class="ting" @click="playSingleAudio('word')">
              <div class="ting-img">
                <img class="" :class="{ 'image-grow': activeAudio === 'word' }" width="70" src="../../static/images/ting.png" />
              </div>
              <span class="text-shadow">{{$t('Listen')}} {{info.num}}</span></div><!-- image-grow -->
            <audio
              ref="audioWord"
              :src="info.audio_path"
              playsinline
              webkit-playsinline
              style="display: none;"
            ></audio>
          </div>
          <div class="download text-shadow disflex">
            <a :href="info.audio_path" class="download-c disflex">
              <div class="download-i">
                <img src="../../static/images/yin.png">
                <div>MP3</div>
              </div>
              <div class="download-n">
                {{info.num}}
                <div class="">{{$t('Download')}}</div>
              </div>
            </a>
            <a :href="info.pdf_path" class="download-c disflex">
              <div class="download-i">
                <img src="../../static/images/pdf.png">
                <div>PDF</div>
              </div>
              <div class="download-n">
                {{info.num}}
                <div class="">{{$t('Download')}}</div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <Dialog ref="levelDialog" type="alert" title="Reminder" width="80" :modalFoot="false">
        <div class="invited-c ac" slot="mdBox" style="">
          <div class="invited-l">
            <h2 class="ac mt30 font-family " style="color: #2a2d5a;font-size: 50px"> {{$t('Grammar_tips')}}</h2>
          </div>
          <div class="sure_btn" @click="closeBuyPopup">
            <button class=" btn6 font-family mt20" style="line-height: 103px;color: #fff;font-size: 30px;" >{{$t('OK')}}</button>
          </div>
        </div>
      </Dialog>
	</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
import md5 from '../../static/js/md5.min.js'
export default {
    components:{
		Header,Dialog
    },
    data() {
      return {
        info:{},
        id:'',
        startTime: 0,
        totalWatchTime: 0,
        reportingInterval: null,
        videoUlr:'',
        videoElement: this.$refs.videoPlayer,
        currentVideo:'Skit',
        VideoPlaying:false,
        VideoReady:false,
        activeAudio:''
      }
    },
    watch: {
    currentVideo() {
      // Reset video state when changing video
      this.VideoPlaying = false;
      this.VideoReady = false;
    }
  },
  // beforeRouteLeave(to, from, next) {
  //   // Pause all video players when leaving
  //   this.pauseAllVideos();
  //   next();  // Continue navigation
  // },
    mounted() {
      // document.addEventListener('visibilitychange', this.handleVisibilityChange);
      // window.addEventListener('beforeunload', this.handleBeforeUnload);
    },
    beforeDestroy() {
      // Clean up event listeners
      // clearInterval(this.reportingInterval);
      // document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      // window.removeEventListener('beforeunload', this.handleBeforeUnload);
    },

    watch: {
      '$route'(to, from) {
        if (to.query.id !== from.query.id) {
          this.id = to.query.id;
          this.getList();
        }
      }
    },
    beforeRouteLeave(to, from, next) {
      const videoPlayer = this.$refs.videoPlayer;
      if (videoPlayer) {
        videoPlayer.pause();
        videoPlayer.currentTime = 0;
      }
      next();  // 继续导航
    },
	created(){
    this.id = this.$route.query.id
    this.videoElement = this.$refs.videoPlayer;
    this.getList()
	},
    methods: {
      playSingleAudio(type) {
        const audioRef = `audio${type.charAt(0).toUpperCase() + type.slice(1)}`;
        if (this.$refs[audioRef]) {
          if(this.activeAudio=='word'){
            this.pauseAllAudios();
            this.clearAudioEventListeners();
            return;
          }
          this.activeAudio = type;
          this.$refs[audioRef].currentTime = 0;
          this.$refs[audioRef].play().catch(e => console.log("播放失败:", e));
          this.$refs[audioRef].onended = () => {
            this.activeAudio = null;
          };
        }
      },
      clearAudioEventListeners() {
        if (this.$refs.audioWord) this.$refs.audioWord.onended = null;
      },
      pauseAllAudios() {
        this.activeAudio = null;
        this.$refs.audioWord.pause();
        this.$refs.audioWord.currentTime = 0;
      },
      changeVideo(type){
        this.currentVideo = type
        if(type=='Skit'){
          this.videoUlr = this.info.short_video
        }else{
          this.videoUlr = this.info.video
        }

        this.VideoPlaying = false;
        this.VideoReady = false;
        this.$nextTick(() => {
          const videoPlayer = this.$refs.videoPlayer;
          if (videoPlayer) {
            videoPlayer.load();
            // 预加载视频
            videoPlayer.preload = "auto";
          }
        });
      },
      back(){
      	this.$router.push({path:'/Conversation'});
      },
      getList(){
        let that = this
        let data = {
          "id":this.id
        }
        that.$parent.loadModal(true);
        that.$api.post('/api/simple_jp/detail',data,r =>{
          that.$parent.returnCode(r,function(){
            that.$parent.loadModal(false);
            that.info = r.data
            that.videoUlr = r.data.short_video
            that.$nextTick(() => {
              that.preloadVideos();
            });
          })
        })
      },
      playVideo(videoType) {
        const videoPlayer = this.$refs.videoPlayer;

        if (videoPlayer) {
          videoPlayer.play().then(() => {
            console.log(`${videoType} video started playing`);
          }).catch(error => {
            console.error(`Error playing ${videoType} video:`, error);
            // 显示错误信息
            // alert(`无法播放视频: ${error.message}`);
          });
        }
      },
      pauseAllVideos() {
        const videoPlayer = this.$refs.videoPlayer;

        if (videoPlayer) {
          videoPlayer.pause();
          videoPlayer.currentTime = 0;
        }
      },
      //播放时间
      reportWatchTime(force = false, finished = false) {
        return;
        const now = Date.now();
        let currentWatch = (now - this.startTime) / 1000;
        this.totalWatchTime += currentWatch;
        this.startTime = now;
        // Don't report if watch time is less than 5 seconds (unless forced)
        if (!force && currentWatch < 5) return;
        let that = this
        let ts = Date.now();
        let seconds = Math.round(this.totalWatchTime);
        let sign = that.generateSign(seconds, ts);
        let data = {
          video_id: this.id,
          seconds: seconds,
          finished: finished,
          video_type: 'mooc',
          ts: ts,
          sign: sign
        }
        that.$api.post('/api/watch/report_time',data,r =>{
          that.$parent.returnCode(r,function(){

          })
        })
      },
      generateSign(score, ts, secret = "jksdfuiAa4so") {
        const str = String(score) + String(ts) + secret
        return md5(str);
      },
      // Check if we should count time (tab visible, playing normally at 1x speed)
      canCountTime() {
        return !document.hidden &&
          !this.videoElement.paused &&
          this.videoElement.playbackRate === 1.0;
      },

      // Start the reporting interval
      startReporting() {
        this.startTime = Date.now();
        if (this.reportingInterval) clearInterval(this.reportingInterval);

        this.reportingInterval = setInterval(() => {
          if (this.canCountTime()) {
            this.reportWatchTime();
          }
        }, 10000); // Report every 10 seconds
      },

      // Event handlers
      onPlay() {
        console.log('开始播放');
        this.videoElement = this.$refs.videoPlayer;
        this.VideoPlaying = true;
        if (!this.videoElement) return;
        if (this.videoElement.playbackRate !== 1.0) {

          this.videoElement.pause();
          return;
        }
        this.startReporting();
      },

      onPause() {
        console.log('暂停播放');
        if (this.canCountTime()) {
          this.reportWatchTime();
        }
        clearInterval(this.reportingInterval);
      },

      onEnded() {
        console.log('播放结束');
        this.reportWatchTime(true, true); // Force report and mark as finished
        clearInterval(this.reportingInterval);
      },

      onSeeking() {
        console.log('拖动进度条');
        // Reset timer when seeking to prevent cheating
        this.startTime = Date.now();
      },

      onRateChange() {
        console.log('倍速播放');
        this.videoElement = this.$refs.videoPlayer;
        if (this.videoElement.playbackRate !== 1.0) {

          this.videoElement.pause();
        }
      },

      // 预加载视频
      preloadVideos() {
        const videoPlayer = this.$refs.videoPlayer;

        if (videoPlayer) {
          videoPlayer.preload = "auto";
          videoPlayer.load();
        }
      },

      // 视频事件处理
      onVideoLoaded(videoType) {
        console.log(`${videoType} video loaded`);
        this.VideoReady = true;
      },

      onVideoError(videoType) {
        console.error(`${videoType} video error`);
        const videoPlayer = this.$refs.videoPlayer;

        if (videoPlayer) {
          console.error('Video error details:', videoPlayer.error);
        }
      },
      handleVisibilityChange() {
        this.videoElement = this.$refs.videoPlayer;
        if (document.hidden) {
          this.reportWatchTime(true);
          clearInterval(this.reportingInterval);
        } else if (!this.videoElement.paused) {
          this.startReporting();
        }
      },

      handleBeforeUnload() {
        this.reportWatchTime(true);
      },
      closeBuyPopup(){
        this.$refs.levelDialog.closeMask();
        this.$router.push({path:'/',query: {}});
      },
      statusText(status) {
        switch (status) {
          case 1: return this.$t('no_start')
          case 2: return this.$t('in_process')
          case 3: return this.$t('finished')
          default: return ''
        }
      }
	}
}
</script>
<style scoped>
.sure_btn{
  display: block;
  width: 70%;           /* 按钮宽度，手机上也合适 */
  max-width: 600px;     /* 最大宽度 */
  margin: 20px auto 0;  /* 居中并有间距 */
  padding: 12px 0;      /* 内边距控制高度 */
  font-size: 18px;      /* 字体大小适中 */
  line-height: normal;  /* 去掉原来的103px */
  background: url('../../static/images/level_button.png') no-repeat center;
  background-size: contain;  /* 图片自适应容器 */
  text-align: center;
  color: #fff;
  text-shadow: 2px 2px 0 #001d8c;
  border: none;
  border-radius: 10px;
  cursor: pointer;
}
.img-box {
  position: relative;
  display: inline-block;
}
.img-box img {
  display: block;
  width: 100%;
  border-radius: 8px;
}
.status-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 8px 20px;
  font-size: 25px;
  color: #fff;

  border-radius: 12px;
}
/* 不同状态颜色 */
.status-1 {
  background: #fd5959;
}
.status-2 {
  background: #fd9901;
}
.status-3 {
  background: #00f474;
}
</style>



// WEBPACK FOOTER //
// src/page/ConversationDetail.vue